<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import event from '@/util/event'
import getWebsiteAjax from '@/util/getWebsiteAjax'

export default {
  name: 'App',
  async created() {
    // const data = await getWebsiteAjax()
    this.$axios.post('/api/studysys/common/getWebsiteAjax').then(({ data }) => {
      this.$store.commit('setValue', data.data)
      document.title = data.data.title
    })
    event.$on('logout', () => {
      this.$store.commit('logout')
      this.$router.push({ name: 'Login' })
    })
  },
}
</script>

<style>
video {
  outline: 0;
}
.edui-default{
  width:760px;
  padding: 0;
}
.el-image-viewer__btn{
  color: #fff;
}
.pointer{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue